import { http } from '@/lib/http';
import type { ListQuery, Page } from '@/types/common';
import type { Tenant, TenantCreatePayload } from '@/types/platform';

const BASE = '/api/v1/platform/tenants';

export const tenantsService = {
  list: (query: ListQuery = {}) => http.get<Page<Tenant>>(BASE, { params: query }),
  get: (id: string) => http.get<Tenant>(`${BASE}/${id}`),
  create: (payload: TenantCreatePayload) => http.post<Tenant, TenantCreatePayload>(BASE, payload),
  update: (id: string, payload: Partial<TenantCreatePayload>) =>
    http.patch<Tenant, Partial<TenantCreatePayload>>(`${BASE}/${id}`, payload),
};
